

















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting_currentUnit } from '@/queries/__generated__/unitInvoiceSetting';
import {
  buildOverdueNoticeProcess,
  IOverdueProcess,
  IProcessInvoice,
} from '@/app/overdue-notice-process';
import {
  buildInterestChargeProcess,
  IInterestProcess,
  IInterestProcessInvoice,
} from '@/app/interest-charge-process';
import OverdueNoticeProcess from './OverdueNoticeProcess.vue';
import OverdueNoticeNextStep from './OverdueNoticeNextStep.vue';
import InterestChargeProcess from './InterestChargeProcess.vue';
import InterestChargeNextStep from './InterestChargeNextStep.vue';
import gql from 'graphql-tag';

type FollowUpMode = 'paymentReminder' | 'interestCharge';

const OVERDUE_INVOICES_SEARCH = gql`
  query overdueInvoicesSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $onlyOverdue: Boolean,
    $filters: InvoiceFilter
  ) {
    invoices(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      onlyOverdue: $onlyOverdue,
      filters: $filters
    ){
      id
      number
      issueDate
      dueDate
      paidDate
      payableAmount
      customerParty {
        id
        name
        unofficialName
      }
      customer {
        id
        email
      }
      supplierParty {
        id
        email
      }
      invoiceOverdueNotices {
        id
        orderNumber
        issueDate
        dueDate
        additionalCharge
        overdueNoticeLogs {
          id
          deliveryStatus
        }
      }
      invoiceInterestCharges {
        id
        interestInvoice {
          id
          number
        }
      }
      interestChargePreview {
        chargeable
        blockedReason
        availableFrom
        fromDate
        toDate
        days
        principalAmount
        interestAmount
        collectionFeeAmount
        totalAmount
        segments {
          fromDate
          toDate
          days
          rate
          amount
        }
      }
    }
  },
`;

@Component({
  components: {
    OverdueNoticeProcess,
    OverdueNoticeNextStep,
    InterestChargeProcess,
    InterestChargeNextStep,
  },
})
export default class OverdueInvoiceList extends Vue {
  @SmartQuery(UNIT_INVOICE_SETTINGS) private currentUnit!: GQL_unitInvoiceSetting_currentUnit;

  private OVERDUE_INVOICES_SEARCH = OVERDUE_INVOICES_SEARCH;

  private mode: FollowUpMode = 'paymentReminder';

  private get usesOverdueNotices(): boolean {
    return !!this.currentUnit?.unitSetting?.unitInvoiceSetting?.usesOverdueNotices;
  }

  private get usesInterestInvoices(): boolean {
    return !!this.currentUnit?.unitSetting?.unitInvoiceSetting?.usesInterestInvoices;
  }

  private get bothModesAvailable(): boolean {
    return this.usesOverdueNotices && this.usesInterestInvoices;
  }

  private get showReminders(): boolean {
    return this.usesOverdueNotices && this.mode === 'paymentReminder';
  }

  private get showInterestCharges(): boolean {
    return this.usesInterestInvoices && this.mode === 'interestCharge';
  }

  // The settings arrive after the first render, so the default is picked when
  // they land. Payment reminders win when both are on: they are the cheaper
  // step for the customer, and the one that has to come first anyway.
  @Watch('currentUnit')
  private pickDefaultMode(): void {
    this.mode = this.usesOverdueNotices ? 'paymentReminder' : 'interestCharge';
  }

  private reminderProcessFor(invoice: IProcessInvoice): IOverdueProcess {
    return buildOverdueNoticeProcess(invoice);
  }

  private interestProcessFor(invoice: IInterestProcessInvoice): IInterestProcess {
    return buildInterestChargeProcess(invoice);
  }
}
